export const templateData = [
  {
    id: 1,
    name: "Elena Park",
    service: "Pre-screening",
    tags: ["General", "In-Person Appointment"],
    creator: {
      type: "Individual",
      name: "Hippocratic AI"
    },
    isNew: false,
    ai: true,
    photo: "/d1.jpg", // Placeholder image
    individualCreator: null,
    specialty: "Cardiology",
    promptId: "Pre-screening",
    subspecialty: "Interventional Cardiology",
    introduction:
      "Ms Elena Park is passionate about preventive care and works closely with her patients to develop personalized health plans. She is known for her compassionate approach, taking the time to listen and thoroughly address each patient's concerns. In her free time, Ms Elena Park enjoys hiking, reading, and volunteering at local health clinics.",
    agenda: {
      title: "Purpose of Call:",
      descipt:
        "To inform the participant that they are eligible for the Lung Cancer Screening Study and to introduce the study details, obtain verbal consent, collect personal details, and arrange for the scan appointment.",
      checklist: [
        "Greet participant and confirm their name",
        "Confirm it’s a good time to talk",
        "Inform them of eligibility for the study",
        "Briefly explain study components: questionnaires, blood draw (30mL, no results), low-dose CT scan",
        "Explain scan schedule (12 or 24 months) based on smoking status",
        "Mention follow-up process and potential referral if abnormalities are found",
        "Ask for verbal consent and explain WhatsApp consent form",
        "Collect participant details",
        "Thank participant and mention follow-up via text with scan details"
      ]
    }
  },
  {
    id: 2,
    name: "Maya Sullivan",
    service: "Auto Check-in",
    tags: ["Virtual Check-In", "Patient Kiosk"],
    creator: {
      type: "Individual",
      name: "Jacob Garcia"
    },
    isNew: false,
    ai: true,
    photo: "/d2.jpg", // Placeholder image
    individualCreator: "Jacob Garcia",
    specialty: "Orthopedic Surgery",
    subspecialty: "Sports Medicine",
    introduction:
      "Ms Maya Sullivan is a distinguished orthopedic surgeon specializing in advanced treatments for musculoskeletal conditions. With extensive training in orthopedic surgery, she focuses on diagnosing and treating injuries and disorders of the bones, joints, ligaments, tendons, and muscles. Ms. Sullivan is particularly known for her expertise in minimally invasive surgical techniques, joint reconstruction, and trauma care.",
    agenda: {
      title: "AI-Powered Patient Check-In",
      descipt:
        "Begin your visit with intelligent check-in. Our AI system helps assess your condition and prepares your care team before you even step in.",
      checklist: [
        "How are you feeling today?",
        "Have you been able to eat or drink anything?",
        "Have you been able to sleep? ",
        "Have you been able to exercise? ",
        "Have you been able to take your medication?"
      ]
    }
  },
  {
    id: 3,
    name: "Liana Chen",
    service: "Preliminary",
    tags: ["Health Assessment", "Surgical Clearance"],
    creator: {
      type: "Individual",
      name: "Hippocratic AI"
    },
    isNew: false,
    ai: true,
    photo: "/d3.jpg", // Placeholder image
    individualCreator: null,
    specialty: "General Surgery",
    subspecialty: "Bariatric Surgery",
    promptId: "Preliminary",
    introduction:
      "Ms Liana Chen is a dedicated and compassionate physician committed to delivering high-quality, patient-centered care. With a strong background in clinical medicine and a focus on personalized treatment, she works closely with individuals to understand their unique health needs and guide them toward better outcomes. Ms. Chen is known for her attentive approach, clear communication, and commitment to continuous learning in the ever-evolving field of healthcare.",
    agenda: {
      title: "Participant Onboarding for Lung Cancer Screening Study",
      descipt:
        "The purpose of the call is to address any questions the participant may have regarding the lung cancer study and to collect personal information needed to schedule study procedures. The study consists of three main components: completing lifestyle-related questionnaires at designated time points, undergoing a one-time blood draw (3 tubes, approximately 30mL) for research purposes only with no results returned, and receiving a low-dose CT scan that provides results, with radiation exposure kept to one-fifth of a typical CT scan.",
      checklist: [
        "Greeting & Introduction",
        "Acknowledge receipt of consent form and Thank participant for joining the study",
        "Explain purpose of call: answer questions and collect personal details",
        "Explain study components",
        "Ask about personal history of cancer",
        "Ask about family history of lung cancer (relationship and age at diagnosis)",
        "Ask about availability for CT scan (offer dates/times)",
        "Ask if MC is required for scan day",
        "Confirm scan appointment and mention follow-up text"
      ]
    }
  },
    {
      id:4,
      name: "Amara Patel",
      service: "Adhoc Task",
      tags: ["Adhoc Task", "Transition of Care"],
      creator: {
        type: "Individual",
        name: "Isabel Hartig MSN, APRN"
      },
      isNew: false,
      ai: true,
      photo: "/d4.png", // Placeholder image
      individualCreator: "Isabel Hartig MSN, APRN",
      specialty: "Psychiatry",
      subspecialty: "Geriatric Psychiatry",
      introduction:"Ms Amara Patel is a compassionate and skilled physician dedicated to providing high-quality care to her patients. With expertise in diagnosing and treating a wide range of health conditions, Ms Patel takes a holistic approach to healthcare, focusing on both physical and emotional well-being. Known for her clear communication and patient-centered care, she works closely with individuals to create personalized treatment plans that promote long-term health and wellness.",
      agenda:{
        title:"TaskCare Solutions",
        descipt:"A dynamic and efficient service designed to address the hospital's immediate and specialized needs. TaskCare Solutions streamlines adhoc tasks, ensuring quick responses to unplanned challenges, optimizing workflow, and supporting seamless patient care. Whether it's coordinating resources, managing urgent requests, or handling operational tasks, TaskCare Solutions ensures your hospital runs smoothly and effectively."
      }
    },
    {
      id:5,
      name: "Hui Ling Tan",
      service: "Post-Discharge",
      tags: ["Post dis-charge", "Transition of Care"],
      creator: {
        type: "Individual",
        name: "Isabel Hartig MSN, APRN"
      },
      isNew: false,
      ai: true,
      photo: "/d2.jpg", // Placeholder image
      individualCreator: "Isabel Hartig MSN, APRN",
      specialty: "Psychiatry",
      subspecialty: "Geriatric Psychiatry",
      introduction:"Ms Hui Ling Tan dedicated physician with over 10 years of clinical experience in internal medicine and post-discharge patient care. Passionate about continuity of care, patient education, and improving recovery outcomes after hospitalization.",
      agenda:{
        title:"TaskCare Solutions",
        descipt:"A dynamic and efficient service designed to address the hospital's immediate and specialized needs. TaskCare Solutions streamlines adhoc tasks, ensuring quick responses to unplanned challenges, optimizing workflow, and supporting seamless patient care. Whether it's coordinating resources, managing urgent requests, or handling operational tasks, TaskCare Solutions ensures your hospital runs smoothly and effectively."
      }
    },
    {
      id:6,
      name: "Hana Lee",
      service: "Incoming Call",
      tags: ["Healthcare Assistant", "Care Continuity"],
      creator: {
        type: "Individual",
        name: "Isabel Hartig MSN, APRN"
      },
      isNew: false,
      ai: true,
      photo: "/d6.png", // Placeholder image
      individualCreator: "Isabel Hartig MSN, APRN",
      specialty: "Family Medicine",
      subspecialty: "Diabetes care, thyroid disorders",
      introduction:"Warm and approachable physician with over 10 years of clinical experience in internal medicine and patient follow-up care. Dedicated to supporting patients after hospital discharge, with a strong focus on continuity of care, recovery monitoring, and empowering patients through clear communication and education. Passionate about making every patient feel heard, supported, and confident in their health journey.",
      agenda:{
        title:"TaskCare Solutions",
        descipt:"A dynamic and efficient service designed to address the hospital's immediate and specialized needs. TaskCare Solutions streamlines adhoc tasks, ensuring quick responses to unplanned challenges, optimizing workflow, and supporting seamless patient care. Whether it's coordinating resources, managing urgent requests, or handling operational tasks, TaskCare Solutions ensures your hospital runs smoothly and effectively.",
        checklist: [
          "Guiding your recovery with care and compassion.",
          "Here to listen, support, and help you heal.",
          "Your health partner, every step of the way.",
          "Personalized care for a smoother recovery.",
          "Dedicated to your well-being, always.",
          "Making healthcare feel human and approachable.",
          "Because every patient’s journey matters."
        ]
      }
    },
    {
      id:7,
      name: "Hana Lee",
      service: "Chatbot Invitation",
      tags: ["Healthcare Assistant", "Care Continuity"],
      creator: {
        type: "Individual",
        name: "Isabel Hartig MSN, APRN"
      },
      isNew: false,
      ai: true,
      photo: "/d6.png", // Placeholder image
      individualCreator: "Isabel Hartig MSN, APRN",
      specialty: "Family Medicine",
      promptId:"PEAR_0001",
      subspecialty: "Diabetes care, thyroid disorders",
      introduction:"Warm and approachable physician with over 10 years of clinical experience in internal medicine and patient follow-up care. Dedicated to supporting patients after hospital discharge, with a strong focus on continuity of care, recovery monitoring, and empowering patients through clear communication and education. Passionate about making every patient feel heard, supported, and confident in their health journey.",
      agenda:{
        title:"Send Chatbot Invitation",
        descipt:"Meet new digital assistant! Our chatbot is to answer your questions instantly, guide you step by step, and provide support anytime—day or night.",
        checklist: [
          "Guiding your recovery with care and compassion.",
          "Here to listen, support, and help you heal.",
          "Your health partner, every step of the way.",
          "Personalized care for a smoother recovery.",
          "Dedicated to your well-being, always.",
          "Making healthcare feel human and approachable.",
          "Because every patient’s journey matters."
        ]
      }
    },
    {
      id: 8,
      name: "Sofia Lim",
      service: "Appointment Reminder",
      tags: ["Reminder", "Follow-Up", "Patient Engagement"],
      creator: {
        type: "Individual",
        name: "Hippocratic AI"
      },
      isNew: true,
      ai: true,
      photo: "/d3.jpg", // Placeholder image
      individualCreator: null,
      specialty: "Family Medicine",
      subspecialty: "Preventive Care",
      promptId: "Appointment Reminder",
      introduction:
        "Ms Sofia Lim is dedicated to helping patients stay on track with their healthcare appointments. She is known for her friendly reminders and proactive communication, ensuring patients never miss an important visit. Sofia believes that timely care is key to long-term health and works closely with patients to support their wellness journey.",
      agenda: {
        title: "Appointment Reminder",
        descipt:
          "To remind the participant of their upcoming appointment, confirm attendance, and answer any questions regarding the visit.",
        checklist: [
          "Greet participant and confirm their name",
          "Remind them of the upcoming appointment date, time, and location",
          "Confirm if they are able to attend",
          "Provide instructions on what to bring or prepare",
          "Answer any questions about the appointment",
          "Offer to reschedule if needed",
          "Thank participant and encourage them to reach out for further assistance"
        ]
      }
    },

    {
      id: 8,
      name: "Sofia Lim",
      service: "Voice Chat",
      tags: ["Reminder", "Follow-Up", "Patient Engagement"],
      creator: {
        type: "Individual",
        name: "Hippocratic AI"
      },
      isNew: true,
      ai: true,
      photo: "/d3.jpg", // Placeholder image
      individualCreator: null,
      specialty: "Family Medicine",
      subspecialty: "Preventive Care",
      promptId: "Appointment Reminder",
      introduction:
        "Ms Sofia Lim is dedicated to helping patients stay on track with their healthcare appointments. She is known for her friendly reminders and proactive communication, ensuring patients never miss an important visit. Sofia believes that timely care is key to long-term health and works closely with patients to support their wellness journey.",
      agenda: {
        title: "Appointment Reminder",
        descipt:
          "To remind the participant of their upcoming appointment, confirm attendance, and answer any questions regarding the visit.",
        checklist: [
          "Greet participant and confirm their name",
          "Remind them of the upcoming appointment date, time, and location",
          "Confirm if they are able to attend",
          "Provide instructions on what to bring or prepare",
          "Answer any questions about the appointment",
          "Offer to reschedule if needed",
          "Thank participant and encourage them to reach out for further assistance"
        ]
      }
    }

  ];

